import { AbuseReason, AbuseReportType, DSAReason, DSAReportType } from '../shared';
import { rootApi } from './rootApi';

interface ReportedContent {
  reporterComment?: string;
  channelId?: string | number;
  channelName?: string;
  storyId?: string | number;
  storyName?: string;
  postId?: string | number;
  postType?: string;
  postTitle?: string;
  authorId?: string | number;
  authorName?: string;
  commentId?: string | number;
  commentText?: string;
  commentAuthorId?: string | number;
  commentAuthorName?: string;
  chatId?: string | number;
  chatName?: string;
  chatType?: string;
  messageId?: string;
  messageText?: string;
  messageAuthorId?: string;
  messageAuthorName?: string;
  messageType?: string;
  userID?: string | number;
  userName?: string;
  userEmail?: string;
  eventId?: string | number;
  eventName?: string;
}

interface AbuseReporter {
  id?: string | number;
  email?: string;
  name?: string;
}

interface DSAReporter {
  email?: string;
  name?: string;
}

export interface AbuseReportBody extends ReportedContent {
  type: AbuseReportType;
  reason: AbuseReason;
  reportedBy?: AbuseReporter;
}

export interface DSAReportBody extends ReportedContent {
  type: DSAReportType;
  reason: DSAReason;
  reportedBy?: DSAReporter;
}

export const reportApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createAbuseReport: builder.mutation<void, AbuseReportBody>({
      query: (body) => ({
        url: '/report/abuse',
        method: 'POST',
        body,
      }),
    }),
    createDSAReport: builder.mutation<void, DSAReportBody>({
      query: (body) => ({
        url: '/report/dsa',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateAbuseReportMutation, useCreateDSAReportMutation } = reportApi;
